import complexConfigurator from './complexConfigurator';
import configurator from './configurator';
import common from './common';
import { getOrCreateProject, ensureFullBleedTemplateOnProject } from './project';
import vp from './vp';

/* global $ */

async function onClick() {
  // validate that the user has made all mandatory selections
  complexConfigurator.callToAction.validateSelection();

  if (
    complexConfigurator.callToAction
      .get('state')
      .get('validation')
      .hasErrorsPresent()
  ) {
    // we manually trigger this event so that the error message shows up next to the cta
    common.dispatcher.trigger(configurator.constants.EVENTS.RERENDER_CTA_ERRORS);
    return;
  }

  const project = await getOrCreateProject();

  try {
    await ensureFullBleedTemplateOnProject(project);
  } catch (error) {
    // if we fail to add the full bleed template to the project (e.g. we can't get a sku) we have to abort

    // log the error
    vp.logError(error.message);

    // fall back to faking a click on the "Start designing" button
    $('.get-started').click();

    return;
  }

  // get the url from the CTAUrlProvider (since we set 'shouldShowMatching' to true, this should be a studio url)
  // we swap out _GetStarted for _UploadDesign in the xnav for tracking purposes
  window.location.href = complexConfigurator.callToActionUrlProvider
    .getCallToActionUrl()
    .replace('_GetStarted', '_UploadDesign');
}

// we're in the test, and we're on
export default function render() {
  const uploadButton = $('<button></button>')
    .attr({
      type: 'button',
      // hack the width to match the "Browse designs" button
      style: 'margin-top: 10px; width: 263px;',
    })
    .addClass('textbutton textbutton-secondary textbutton-super')
    .text('Upload an existing design')
    .on('click', onClick);

  $('.get-started-view').append(uploadButton);

  // when upload button renders, change the get-started button text to "Browse designs"
  $('.get-started').text('Browse designs');
}
